/* =========================================================================
   WallCast — theme.js
   Vanilla JS, data-attribute driven. Every behavior no-ops when its
   elements are absent. See DESIGN-CONTRACT.md for markup contracts.
   ========================================================================= */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    initGalleries();
    initAccordions();
    initTiers();
    initScrollTo();
    initStickyAtc();
    initReveal();
    initRotators();
  });

  /* ---------- Gallery: [data-gallery] ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main] img') ||
                 gallery.querySelector('img[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src) return;
          main.src = src;
          main.alt = thumb.getAttribute('data-alt') || main.alt;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Accordion: [data-accordion] ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var items = accordion.querySelectorAll('[data-accordion-item]');
      if (!items.length) return;

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-accordion-trigger]');
        var panel = item.querySelector('[data-accordion-panel]');
        if (!trigger || !panel) return;

        var startOpen = trigger.getAttribute('aria-expanded') === 'true' ||
                        item.classList.contains('is-open');
        setState(item, trigger, panel, startOpen);

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          // Close siblings — one open at a time per container.
          items.forEach(function (other) {
            if (other === item) return;
            var oTrigger = other.querySelector('[data-accordion-trigger]');
            var oPanel = other.querySelector('[data-accordion-panel]');
            if (oTrigger && oPanel) setState(other, oTrigger, oPanel, false);
          });
          setState(item, trigger, panel, !isOpen);
        });
      });
    });

    function setState(item, trigger, panel, open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.classList.toggle('is-open', open);
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    }
  }

  /* ---------- Pricing tiers: [data-tiers] ---------- */
  function initTiers() {
    document.querySelectorAll('[data-tiers]').forEach(function (group) {
      var tiers = group.querySelectorAll('[data-tier]');
      if (!tiers.length) return;

      var form = group.closest('form');

      function apply(tier) {
        var price = tier.getAttribute('data-price') || '';
        var compare = tier.getAttribute('data-compare') || '';
        var variant = tier.getAttribute('data-variant') || '';

        tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });

        document.querySelectorAll('[data-price-current]').forEach(function (el) {
          el.textContent = price;
        });
        document.querySelectorAll('[data-price-compare]').forEach(function (el) {
          el.textContent = compare;
          el.style.display = compare ? '' : 'none';
        });
        document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
          el.textContent = price;
        });

        var idInput = form ? form.querySelector('input[name="id"]')
                           : document.querySelector('input[name="id"]');
        if (idInput && variant) idInput.value = variant;
      }

      tiers.forEach(function (tier) {
        var radio = tier.querySelector('input[type="radio"]');
        if (radio) {
          radio.addEventListener('change', function () { apply(tier); });
        } else {
          tier.addEventListener('click', function () { apply(tier); });
        }
      });

      // Respect the pre-checked tier on load.
      var checked = group.querySelector('input[type="radio"][checked], input[type="radio"]:checked');
      var initial = checked ? checked.closest('[data-tier]') : tiers[0];
      if (initial) apply(initial);
    });
  }

  /* ---------- Smooth scroll: [data-scroll-to] ---------- */
  function initScrollTo() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-scroll-to]');
      if (!el) return;
      var target = document.querySelector(el.getAttribute('data-scroll-to'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Sticky add-to-cart: [data-sticky-atc] ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var buyBox = document.querySelector('#buy-box');
    if (!bar || !buyBox || !('IntersectionObserver' in window)) return;

    var buyBoxVisible = true;
    var footerVisible = false;
    var buyBoxPassed = false;

    function update() {
      var show = !buyBoxVisible && !footerVisible && buyBoxPassed;
      bar.classList.toggle('is-visible', show);
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        buyBoxVisible = entry.isIntersecting;
        if (!entry.isIntersecting) {
          buyBoxPassed = entry.boundingClientRect.bottom < 0;
        }
      });
      update();
    }, { threshold: 0 }).observe(buyBox);

    var footer = document.querySelector('footer, .shopify-section-group-footer-group, [data-footer]');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { footerVisible = entry.isIntersecting; });
        update();
      }, { threshold: 0 }).observe(footer);
    }
  }

  /* ---------- Reveal on scroll: .reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Announcement rotator: [data-rotate] ---------- */
  function initRotators() {
    document.querySelectorAll('[data-rotate]').forEach(function (rotator) {
      var items = Array.prototype.slice.call(rotator.children);
      if (items.length < 2) {
        if (items[0]) items[0].classList.add('is-active');
        return;
      }
      var index = 0;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === 0);
      });
      setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 5000);
    });
  }
})();
